import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AutoCompleteComponent } from '../../auto-complete/auto-complete.component';
import { CheckboxComponent } from '../../checkbox/checkbox.component';
import { DateComponent } from '../../date/date.component';
import { InputComponent } from '../../input/input.component';
import { RadioGroupComponent } from '../../radio-group/radio-group.component';
import { SelectDropdownComponent } from '../../select-dropdown/select-dropdown.component';
import { TextareaComponent } from '../../textarea/textarea.component';

@Component({
  selector: 'app-dynamic-field',
  standalone: true,
  imports: [
    CommonModule,
    AutoCompleteComponent,
    CheckboxComponent,
    DateComponent,
    InputComponent,
    RadioGroupComponent,
    SelectDropdownComponent,
    TextareaComponent,
    NgbModule
  ],
  templateUrl: './dynamic-field.component.html',
  styleUrl: './dynamic-field.component.scss'
})
export class DynamicFieldComponent implements OnInit, AfterViewInit {
  @Input() field: any;
  @Output() requiredKey = new EventEmitter<any>();
  @Output() selecteditem = new EventEmitter<any>();
  @Output() selectedItems = new EventEmitter<any>();
  @Output() reloadOptions = new EventEmitter<any>();

  tabEdited: number[] = [];
  initialLoadComplete = false;

  ngOnInit(): void {
    if (this.field?.type === 'tabs') {
      console.log('🟦 Tabs field initialized:', this.field);
    }
  }

  ngAfterViewInit(): void {
    // Delay for a short time after first render to let all initial bindings finish
    setTimeout(() => {
      this.initialLoadComplete = true;
      console.log('✅ Initial load complete — user edits will now be tracked');
    }, 1000);
  }

  markTabAsEdited(tabId: number, event: any, eventType: string) {
    if (!this.initialLoadComplete) {
      // Ignore all events fired during initial data binding
      return;
    }

    if (!this.tabEdited.includes(tabId)) {
      this.tabEdited.push(tabId);
      console.log(`🟨 Tab ${tabId} marked as edited due to ${eventType}`);
    }
  }

  isTabEdited(tabId: number): boolean {
    return this.tabEdited.includes(tabId);
  }
}
